// extracted by mini-css-extract-plugin
export default {"FormItemContainer":"ExtensionForm_FormItemContainer__6uY5B"};